export default __webpack_public_path__ + "static/media/GreenIndicator.638fa766.jpg";